import { ExternalLinkIcon, StarIcon } from '../icons'
import type { ReviewStrings } from './menuI18n'

/**
 * Google değerlendirme kartı (31 Eki 2026): menünün sonunda ve QR Siparişte
 * hesap istenince açılan pencerede. Yalnız patron Ayarlar › QR Menü'ye
 * bağlantı girdiyse çiziliyor; bağlantı reviewLink'ten geçmiş olmalı.
 */
export function ReviewCard({ url, t }: { url: string; t: ReviewStrings }) {
  return (
    <div className="pm__review">
      <span className="pm__review-stars" aria-hidden="true">
        {[0, 1, 2, 3, 4].map((i) => (
          <StarIcon key={i} filled />
        ))}
      </span>
      <div className="pm__review-text">
        <b>{t.title}</b>
        <span>{t.sub}</span>
      </div>
      <a className="pm__review-go" href={url} target="_blank" rel="noopener noreferrer">
        {t.cta}
        <ExternalLinkIcon />
      </a>
    </div>
  )
}
